import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojalgaon() {



  const cardData =
  {
    keyword: 'Mumbai to Jalgaon Cab Booking ',
    heading: 'Shambhu Cabs: Mumbai to Jalgaon Cab Booking  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Jalgaon Cab Booking services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and long-distance travelers heading to Jalgaon. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient journey from Mumbai to Jalgaon with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and enjoyable. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Jalgaon cab services for travelers seeking comfort, safety, and reliability throughout the journey',

    top: 'Top Places to Visit in Jalgaon with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves, a UNESCO World Heritage Site near Jalgaon, are ancient rock-cut Buddhist caves dating from the 2nd century BCE to 480 CE. Known for their intricate sculptures, murals, and paintings, they are a masterpiece of Indian art and architecture."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, located near Jalgaon, are an extensive complex of rock-cut temples and monasteries representing Buddhist, Hindu, and Jain traditions. The Kailasa temple is a remarkable example of monolithic rock excavation and architectural brilliance."
  },
  {
    "title": "Gautala Autramghat Sanctuary",
    "description": "Gautala Autramghat Wildlife Sanctuary is a lush forested area home to leopards, bears, deer, and various bird species. Visitors can enjoy trekking, wildlife spotting, and peaceful nature walks amid scenic landscapes."
  },
  {
    "title": "Patnadevi Temple",
    "description": "Patnadevi Temple is an ancient hilltop temple dedicated to Goddess Patnadevi, located amidst serene forests. The temple is popular for its spiritual significance, peaceful surroundings, and scenic views of the Satpura ranges."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is a historical water mill in Jalgaon, known for its ingenious hydraulic system. Built during the medieval period, it demonstrates traditional engineering and attracts visitors interested in history and architecture."
  },
  {
    "title": "Muktai Temple",
    "description": "Muktai Temple, dedicated to the saint Muktai, is an important pilgrimage site near Jalgaon. Devotees visit for spiritual blessings, and the temple is surrounded by a peaceful and serene environment."
  },
  {
    "title": "Baneshwar Temple",
    "description": "Baneshwar Temple is an ancient Shiva temple located near Jalgaon. Nestled in a scenic forested area, it is popular among devotees and tourists for its religious significance and tranquil surroundings."
  },
  {
    "title": "Ajanta-Ellora Interpretation Centre",
    "description": "The Interpretation Centre provides visitors with historical, architectural, and cultural insights into the Ajanta and Ellora caves. It enhances the understanding of the UNESCO World Heritage Sites and their artistic importance."
  },
  {
    "title": "Satpura Trekking Trails",
    "description": "The Satpura ranges near Jalgaon offer trekking trails with scenic views, waterfalls, and wildlife spotting opportunities. Adventurers and nature lovers explore these trails for outdoor activities and exploration."
  },
  {
    "title": "Chalisgaon Ganpati Temple",
    "description": "Chalisgaon Ganpati Temple is a revered local temple dedicated to Lord Ganesha. It attracts devotees for worship, festivals, and cultural gatherings, reflecting the religious traditions of the region."
  }
],


"services": [
  {
    "name": "Mumbai Jalgaon Taxi",
    "description": "Mumbai Jalgaon Taxi provides reliable and comfortable intercity travel from Mumbai to Jalgaon. With professional drivers, well-maintained vehicles, and flexible booking options, this service ensures a smooth journey. Ideal for family trips, business travel, and leisure travelers, passengers can enjoy timely pickups, safe driving, and a stress-free road trip experience."
  },
  {
    "name": "Jalgaon Cab from Mumbai",
    "description": "Jalgaon Cab from Mumbai offers convenient and hassle-free transportation for travelers heading to Jalgaon. Equipped with comfortable sedans and SUVs, the service ensures professional drivers, scenic routes, and punctual arrivals, making it perfect for long-distance travel, sightseeing, and corporate trips."
  },
  {
    "name": "Mumbai Dhule Cab Service",
    "description": "Mumbai Dhule Cab Service provides reliable and efficient travel between Mumbai and Dhule. With experienced drivers, clean vehicles, and flexible schedules, passengers can enjoy a safe and smooth journey. Suitable for family trips, business commutes, and leisure travelers seeking dependable transportation."
  },
  {
    "name": "One-Way Cab Mumbai Jalgaon",
    "description": "One-Way Cab Mumbai Jalgaon is designed for travelers who need single-drop transportation without a return trip. Ideal for business trips, airport transfers, or personal travel, this service ensures economical pricing, professional drivers, and a comfortable ride directly to Jalgaon."
  },
  {
    "name": "One-Way Cab Mumbai Dhule",
    "description": "One-Way Cab Mumbai Dhule provides convenient and cost-effective transportation from Mumbai to Dhule without a return journey. Passengers benefit from punctual pickups, safe driving, and comfortable seating, making it suitable for both leisure and business travelers."
  },
  {
    "name": "Affordable Jalgaon Cab Mumbai",
    "description": "Affordable Jalgaon Cab Mumbai offers budget-friendly options for intercity travel from Mumbai to Jalgaon. Despite economical pricing, the service maintains high standards of vehicle quality, safety, and passenger comfort. Perfect for students, solo travelers, and families seeking cost-effective travel solutions."
  },
  {
    "name": "SUV Cab Mumbai Jalgaon",
    "description": "SUV Cab Mumbai Jalgaon caters to groups or families traveling together, providing spacious and comfortable vehicles for long-distance trips. Equipped with modern amenities and safety features, these SUVs ensure a smooth journey and ample luggage space, ideal for extended road trips."
  },
  {
    "name": "Sedan Cab Mumbai Dhule",
    "description": "Sedan Cab Mumbai Dhule offers elegant and efficient sedans for travelers seeking comfort and economy. With professional drivers and well-maintained vehicles, passengers can enjoy a smooth and relaxed ride from Mumbai to Dhule, suitable for couples, small families, and business travelers."
  },
  {
    "name": "24×7 Taxi Mumbai Jalgaon Dhule",
    "description": "24×7 Taxi Mumbai Jalgaon Dhule provides round-the-clock availability for passengers traveling between Mumbai, Jalgaon, and Dhule. With on-demand booking, flexible timing, and experienced drivers, this service ensures a convenient and safe travel experience at any hour."
  },
  {
    "name": "Fast Cab Mumbai Jalgaon",
    "description": "Fast Cab Mumbai Jalgaon focuses on efficient and time-saving travel. With direct routes, professional drivers, and well-maintained vehicles, passengers can reach their destination quickly while enjoying a comfortable and safe journey, ideal for urgent business trips or tight schedules."
  },
  {
    "name": "Corporate Cab Mumbai Dhule",
    "description": "Corporate Cab Mumbai Dhule is designed for business travelers and corporate clients. With premium vehicles, professional chauffeurs, and timely service, the cab ensures a comfortable and reliable journey for meetings, conferences, or corporate visits between Mumbai and Dhule."
  },
  {
    "name": "Best Cab Mumbai Jalgaon",
    "description": "Best Cab Mumbai Jalgaon is known for its top-quality vehicles, punctual service, and professional drivers. Passengers can enjoy a hassle-free journey, comfortable seating, and safe driving, making it the preferred choice for both leisure and business travel to Jalgaon."
  },
  {
    "name": "Outstation Cab Mumbai Dhule",
    "description": "Outstation Cab Mumbai Dhule specializes in long-distance travel from Mumbai to Dhule. With a focus on safety, comfort, and customer satisfaction, the service provides well-maintained vehicles and experienced drivers, making the journey smooth and enjoyable for all passengers."
  },
  {
    "name": "Premium Cab Jalgaon Mumbai",
    "description": "Premium Cab Jalgaon Mumbai offers luxury vehicles and chauffeur-driven services for travelers seeking a high-end experience. Ideal for VIPs, executives, and special occasions, this service ensures comfort, style, and maximum convenience on the road from Jalgaon to Mumbai."
  },
  {
    "name": "Safe Taxi Mumbai Jalgaon",
    "description": "Safe Taxi Mumbai Jalgaon prioritizes passenger safety with trained drivers, well-maintained vehicles, and adherence to safety protocols. Suitable for families, solo travelers, and corporate clients, this service ensures a secure and dependable journey from Mumbai to Jalgaon."
  },
  {
    "name": "Mumbai Jalgaon Pickup Drop",
    "description": "Mumbai Jalgaon Pickup Drop offers door-to-door service, providing maximum convenience for passengers traveling to Jalgaon. Professional drivers, comfortable vehicles, and flexible timings ensure a seamless and stress-free journey from Mumbai to the destination."
  },
  {
    "name": "Mumbai Dhule Car Rental",
    "description": "Mumbai Dhule Car Rental provides a wide range of cars for hire with professional drivers for intercity travel. Suitable for family trips, corporate travel, or leisure journeys, this service ensures comfortable, safe, and timely transportation from Mumbai to Dhule."
  }
],

"tableData": [
  ["Mumbai Jalgaon Taxi", "Jalgaon Cab from Mumbai"],
  ["Mumbai Dhule Cab Service", "One-Way Cab Mumbai Jalgaon"],
  ["One-Way Cab Mumbai Dhule", "Affordable Jalgaon Cab Mumbai"],
  ["SUV Cab Mumbai Jalgaon", "Sedan Cab Mumbai Dhule"],
  ["24×7 Taxi Mumbai Jalgaon Dhule", "Fast Cab Mumbai Jalgaon"],
  ["Corporate Cab Mumbai Dhule", "Best Cab Mumbai Jalgaon"],
  ["Outstation Cab Mumbai Dhule", "Premium Cab Jalgaon Mumbai"],
  ["Safe Taxi Mumbai Jalgaon", "Mumbai Jalgaon Pickup Drop"],
  ["Mumbai Dhule Car Rental", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Jalgaon Cab Booking / Dhule with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Jalgaon and Dhule cab services, perfect for business trips, family travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and comfortable journey to Jalgaon or Dhule."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Jalgaon and Dhule routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Jalgaon / Dhule cab trip stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Jalgaon or Dhule travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Jalgaon / Dhule journey stress-free and comfortable."
  }
]























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Jalgaon / Dhule cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Jalgaon and Dhule cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Jalgaon / Dhule cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Jalgaon / Dhule cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for long-distance travel to Jalgaon and Dhule from Mumbai.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Jalgaon / Dhule route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the routes to Jalgaon and Dhule, ensuring a smooth and safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Jalgaon / Dhule cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Jalgaon or Dhule.',
  },
  {
    question: 'Is the Mumbai to Jalgaon / Dhule cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Jalgaon / Dhule cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Jalgaon / Dhule cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Jalgaon / Dhule cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Jalgaon / Dhule journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Jalgaon / Dhule travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Patil',
    feedback: 'Our Mumbai to Jalgaon trip with Shambhu Cabs was comfortable and on time. Excellent service and polite driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Highly reliable Mumbai to Dhule cab service. Smooth journey and professional support from Shambhu Cabs throughout.',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jalgaon / Dhule Cab Booking",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-jalgaon-dhule-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Jalgaon and Dhule cab services for one-way and round trips. Book sedans, SUVs, or premium cars for corporate travel, family trips, and outstation journeys. Enjoy safe, fast, and affordable taxi service with 24×7 availability and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-jalgaon-dhule-cab-booking"
  }
};





  return (
    <div>

<Helmet>
  <title>Mumbai to Jalgaon / Dhule Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Jalgaon and Dhule cab with Shambhu Cabs. Affordable, fast, and safe taxi service for one-way and round trips, corporate travel, family trips, and outstation journeys. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Jalgaon Taxi, Jalgaon Cab from Mumbai, Mumbai Dhule Cab Service, One-Way Cab Mumbai Jalgaon, One-Way Cab Mumbai Dhule, Affordable Jalgaon Cab Mumbai, SUV Cab Mumbai Jalgaon, Sedan Cab Mumbai Dhule, 24×7 Taxi Mumbai Jalgaon Dhule, Fast Cab Mumbai Jalgaon, Corporate Cab Mumbai Dhule, Best Cab Mumbai Jalgaon, Outstation Cab Mumbai Dhule, Premium Cab Jalgaon Mumbai, Safe Taxi Mumbai Jalgaon, Mumbai Jalgaon Pickup Drop, Mumbai Dhule Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojalgaon;